import React from 'react';
import {observer} from 'mobx-react';
import {permission_list, vms_list, vms_list_original} from '../../userData.js';
import {active_perm} from '../../activeVM.js';
import {vm_cache} from '../util/WebconnectFrame.js';


export const ActiveConnections = observer(() => {

  // Do not display if nothing is in the VM cache
  if([...vm_cache.entries()].length === 0) return null;

  const get_permission_for_cache_key = key => {
    const permissions = permission_list.get();

    if(permissions[key]) return permissions[key];

    if(key.startsWith('pool')) {
      const [_, pool_id, access_id] = key.split('_');

      // Prefer the explicit access id when available (pool_<poolId>_<accessId>).
      if(access_id && permissions[access_id]) return permissions[access_id];
      if(pool_id && permissions[pool_id]) return permissions[pool_id];

      // Some pooled sessions only provide pool_<poolId>. Fall back to the
      // matching vmpool permission by vm.id so labels still render.
      if(pool_id) {
        const pool_permission = Object.values(permissions).find(permission => {
          if(!permission) return false;

          const is_pool_permission_type = (permission.type === 'vmpool' || permission.type === 'vmpool-app');
          const has_vm = Boolean(permission.vm);
          const matches_pool_id = has_vm && String(permission.vm.id) === String(pool_id);
          return is_pool_permission_type && matches_pool_id;
        });

        if(pool_permission) return pool_permission;
      }
    }

    return null;
  };

  const vm_display_name = perm_id => {
    const permission = get_permission_for_cache_key(perm_id);
    const vm_from_original = vm_id =>
      vms_list_original.get().find(({id}) => String(id) === String(vm_id));

    const get_vm_descriptor = vm_id => {
      if(!vm_id) return '';

      const vm = vms_list.get()[vm_id] || vm_from_original(vm_id);
      return (vm && (vm.descriptor || vm.description || vm.name)) || '';
    };

    if(!permission) {
      // if hash is embedded into url but not on permission list
      if(perm_id && perm_id.startsWith('pool')) {
        const [_, pool_id] = perm_id.split('_');
        const pool_name = get_vm_descriptor(pool_id);
        return pool_name ? `Desktop, ${pool_name}` : 'Desktop';
      }

      // fallback for direct keys that represent VM ids
      const vm_name = get_vm_descriptor(perm_id);
      return vm_name ? `Desktop, ${vm_name}` : 'Desktop';
    }

    const type = permission.type;
    const is_pool_type = (type === 'vmpool' || type === 'vmpool-app');
    const direct_vm_id = permission.vm && permission.vm.id;
    const pool_vm_id = permission.pool_vm && permission.pool_vm.id;
    const latest_pool_vm_id = permission.last_vmpool_vm_id;
    const vm_id = is_pool_type
      // Keep pool identity visible in the sidebar label.
      ? direct_vm_id
      : (latest_pool_vm_id || pool_vm_id || direct_vm_id);

    const vm_desc = get_vm_descriptor(vm_id);
    const perm_desc = (type === 'vm' || type === 'vmpool')
      ? 'Desktop'
      : ((permission.app && permission.app.display_name) || 'Desktop');

    return vm_desc ? (perm_desc + ', ' + vm_desc) : perm_desc;
  };


  return (

    <div className='scroll-inner'>
      <div className="computers-list" id="the-active-vms-list">
         <div className="accordion">
            <div className="card">
               <div className="card-header">
                  <h4 className="mb-0">
                     <i className="fa fa-desktop" aria-hidden="true" style={{color: "#fff"}}></i> Active Connections
                  </h4>
               </div>
            </div>
          </div>


          <ul className="computer-list list-items user-pc active-connections" id="active-connection-list">

            {

              [...vm_cache.keys()]
            //    .filter(perm_id => perm_id.startsWith('pool') || permission_list.get()[perm_id])
                .map(perm_id =>

                <li key={perm_id}
                  className="the-menu-parent active-connections"
                  style={{
                    backgroundColor: active_perm.get() === perm_id ? "#007bff" : "inherit",
                    display: 'flex',
                    whiteSpace: 'nowrap',
                    justifyContent: 'space-between'
                  }}>

                  <a href="#."
                    title={vm_display_name(perm_id)}
                    onClick={(e) => {
                      e.preventDefault()
                      active_perm.set(perm_id)
                    }}
                    style={{
                      overflow: 'hidden',
                      minWidth: 0,
                      textOverflow: 'ellipsis',
                      padding: '3px',
                      paddingLeft: '15px'
                    }}>
                    {vm_display_name(perm_id)}
                  </a>

                  <div className="status-bar" id="status-bar">
                    <i className="fa-custom fa fa-times signout-button status-icon-bg-hover-only"
                      aria-hidden="true"
                      title="Close"
                      style={{paddingRight: '6px'}}
                      onClick={e => {

                        // to refresh:
                        // active_perm.set(); active_perm.set(perm_id);

                        vm_cache.delete(perm_id);
                        if(active_perm.get() === perm_id) active_perm.set();

                      }}>
                    </i>
                  </div>
                </li>

              )

            }

          </ul>

       </div>
    </div>

  );

})
